<div class="dialog-content">
  <div class="create-version-content mx-auto">
    <p class="subtext mt-0">{{ 'CREATE_VERSION.SUBTEXT' | translate }}</p>

    <form [formGroup]="form" novalidate autocomplete="off">
      <!-- Version Name -->
      <p-iconfield iconPosition="right" class="mb-4">
        <p-floatlabel variant="on">
          <input pInputText id="name" formControlName="name" class="w-full" />
          <label for="name">{{ 'CREATE_VERSION.LBL_NAME' | translate }}</label>
        </p-floatlabel>
        <p-inputicon>
          <span class="char-counter">{{ 50 - (form.get('name')?.value?.length || 0) }}/50</span>
        </p-inputicon>
      </p-iconfield>

      <!-- PDF Settings Section -->
      <div class="pdf-settings-section mb-4">
        <div class="flex align-items-center gap-2 mb-3">
          <i class="pi pi-file-pdf text-secondary"></i>
          <span class="font-medium text-secondary">{{ 'CREATE_VERSION.PDF_SETTINGS' | translate }}</span>
        </div>

        <p-floatlabel variant="on" class="w-full mb-3">
          <p-select formControlName="versionLanguage" [options]="availableLangs()" class="w-full" appendTo="body"
            inputId="versionLanguage">
            <ng-template #selectedItem let-selected>
              <div class="language-option">
                <img [src]="getLanguageFlagUrl(selected)" alt="" class="select-flag" />
                {{ 'CREATE_VERSION.VERSION_LANGUAGE_CODES.' + (selected | uppercase) | translate }}
              </div>
            </ng-template>
            <ng-template #item let-language>
              <div class="language-option">
                <img [src]="getLanguageFlagUrl(language)" alt="" class="select-flag" />
                {{ 'CREATE_VERSION.VERSION_LANGUAGE_CODES.' + (language | uppercase) | translate }}
              </div>
            </ng-template>
          </p-select>
          <label for="versionLanguage">{{ 'CREATE_VERSION.LBL_VERSION_LANGUAGE' | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on" class="w-full">
          <p-select formControlName="versionCurrency" [options]="currencies()" optionLabel="code" optionValue="code"
            class="w-full" appendTo="body" inputId="versionCurrency">
            <ng-template #selectedItem let-selected>
              <div class="currency-option">
                <img [src]="getCurrencyFlagUrl(selected.code)" alt="" class="select-flag" />
                {{ selected.code }}
              </div>
            </ng-template>
            <ng-template #item let-currency>
              <div class="currency-option">
                <img [src]="getCurrencyFlagUrl(currency.code)" alt="" class="select-flag" />
                {{ currency.code }}
              </div>
            </ng-template>
          </p-select>
          <label for="versionCurrency">{{ 'CREATE_VERSION.LBL_VERSION_CURRENCY' | translate }}</label>
        </p-floatlabel>
      </div>

      <div class="warnings-container">
        @if (displayCurrencyChangeWarning()) {
        <p class="warning-text">{{ 'CREATE_VERSION.CURRENCY_CHANGE_WARNING' | translate }}</p>
        }
        @if (form.get('name').errors?.versionNameInvalidCharacter) {
        <p class="warning-text">{{ 'CREATE_VERSION.INVALID_CHARACTERS_WARNING' | translate }}</p>
        }
        @if (form.get('name').errors?.versionNameInvalid) {
        <p class="warning-text">{{ 'CREATE_VERSION.INVALID_NAME_WARNING' | translate }}</p>
        }
      </div>

      <!-- Actions -->
      <div class="flex justify-content-end gap-2">
        <button pButton type="button" [label]="'ABORT' | translate" class="p-button-text"
          (click)="closeDialog()"></button>
        <button pButton type="button" [label]="'CREATE.TITLE' | translate" (click)="createVersion()"
          [disabled]="!form.valid"></button>
      </div>
    </form>
  </div>
</div>